<div class="qc-panel">
  <div class="summary-strip">
    <div class="summary-item">
      <span class="summary-label">Added Errors</span>
      <span class="summary-value">{{ addedErrorsCount }}</span>
    </div>

    <div class="summary-item total-events-item">
      <label class="summary-label" for="qc-total-events">Total Events</label>
      <input
        id="qc-total-events"
        type="number"
        min="0"
        class="form-control total-events-input"
        [ngModel]="qc.totalEvents"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onTotalEventsChanged($event)"
      />
    </div>

    <div class="summary-item">
      <span class="summary-label">Error %</span>
      <span class="summary-value">
        {{ errorPercentage === null ? '—' : (errorPercentage | number : '1.2-2') + '%' }}
      </span>
    </div>

    <div class="summary-item">
      <span class="summary-label">Accuracy %</span>
      <span class="summary-value">
        {{
          accuracyPercentage === null
            ? '—'
            : (accuracyPercentage | number : '1.2-2') + '%'
        }}
      </span>
    </div>
  </div>

  <table mat-table [dataSource]="qc.errors" class="errors-table mat-elevation-z2">
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>#</th>
      <td mat-cell *matCellDef="let _row; let i = index">
        <span class="index-value">{{ i + 1 }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="period">
      <th mat-header-cell *matHeaderCellDef>Period</th>
      <td mat-cell *matCellDef="let row">
        <select
          class="form-control"
          [(ngModel)]="row.period"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onFieldChanged()"
        >
          <option [ngValue]="null">Select period...</option>
          <option *ngFor="let period of periods" [ngValue]="period">
            {{ period }}
          </option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="gameTime">
      <th mat-header-cell *matHeaderCellDef>Game Time</th>
      <td mat-cell *matCellDef="let row">
        <input
          type="text"
          class="form-control"
          [class.invalid-field]="isGameTimeInvalid(row)"
          placeholder="MM:SS"
          maxlength="5"
          [ngModel]="row.gameTime"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onGameTimeChanged(row, $event)"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="errorType">
      <th mat-header-cell *matHeaderCellDef>Error</th>
      <td mat-cell *matCellDef="let row">
        <select
          class="form-control"
          [ngModel]="row.errorType"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onErrorTypeChanged(row, $event)"
        >
          <option [ngValue]="null">Select type...</option>
          <option *ngFor="let option of errorTypeOptions" [ngValue]="option.value">
            {{ option.label }}
          </option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="collector">
      <th mat-header-cell *matHeaderCellDef>Collector</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="shouldShowCollectorSelect(row); else collectorPlaceholder">
          <select
            class="form-control"
            [(ngModel)]="row.collector"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onFieldChanged()"
          >
            <option [ngValue]="null">Select collector...</option>
            <option *ngFor="let option of outcomeOptions" [ngValue]="option">
              {{ option }}
            </option>
          </select>
        </ng-container>
        <ng-template #collectorPlaceholder>
          <div class="cell-placeholder"></div>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="qc">
      <th mat-header-cell *matHeaderCellDef>QC</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="shouldShowQcSelect(row)">
          <select
            class="form-control"
            [(ngModel)]="row.qc"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onFieldChanged()"
          >
            <option [ngValue]="null">Select QC...</option>
            <option *ngFor="let option of outcomeOptions" [ngValue]="option">
              {{ option }}
            </option>
          </select>
        </ng-container>

        <ng-container *ngIf="shouldShowQcTextInput(row)">
          <input
            type="text"
            class="form-control"
            [placeholder]="getQcPlaceholder(row)"
            [ngModel]="row.qc"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onQcTextChanged(row, $event)"
          />
        </ng-container>

        <div
          class="cell-placeholder"
          *ngIf="!shouldShowQcSelect(row) && !shouldShowQcTextInput(row)"
        ></div>
      </td>
    </ng-container>

    <ng-container matColumnDef="comment">
      <th mat-header-cell *matHeaderCellDef>QC Comment</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="shouldShowComment(row); else commentPlaceholder">
          <input
            type="text"
            class="form-control"
            [ngModel]="row.comment"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onCommentChanged(row, $event)"
          />
        </ng-container>
        <ng-template #commentPlaceholder>
          <div class="cell-placeholder"></div>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let _row; let i = index" class="actions-cell">
        <button
          mat-icon-button
          type="button"
          (click)="removeError(i)"
          aria-label="Remove QC error row"
        >
          <mat-icon>close</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="errorColumns"></tr>
    <tr
      mat-row
      *matRowDef="let _row; let i = index; columns: errorColumns"
      [class.alt-error-row]="i % 2 === 1"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell empty-row" [attr.colspan]="errorColumns.length">
        No errors added.
      </td>
    </tr>
  </table>

  <button
    mat-button
    type="button"
    class="add-error-button"
    (click)="addError()"
  >
    + Add error
  </button>

  <div class="post-qc-section">
    <div class="post-qc-label">Post QC Obligations</div>
    <div class="post-qc-options">
      <mat-checkbox
        [checked]="qc.postQcObligations.correction"
        (change)="onObligationChanged('correction', $event.checked)"
      >
        Correction
      </mat-checkbox>

      <mat-checkbox
        [checked]="qc.postQcObligations.qaMeeting"
        (change)="onObligationChanged('qaMeeting', $event.checked)"
      >
        QA Meeting
      </mat-checkbox>

      <mat-checkbox
        [checked]="qc.postQcObligations.reCollection"
        (change)="onObligationChanged('reCollection', $event.checked)"
      >
        Re-collection
      </mat-checkbox>
    </div>
  </div>

  <div class="panel-actions">
    <span class="save-status" *ngIf="hasPendingChanges">
      Unsaved changes
    </span>
    <button
      mat-flat-button
      color="accent"
      type="button"
      (click)="saveAndClose()"
      [disabled]="!hasPendingChanges"
    >
      Save
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="toggleDone()"
      [class.mark-undone-button]="isDone"
    >
      {{ isDone ? 'Mark as Undone' : 'Mark as Done' }}
    </button>
  </div>
</div>
